import { TicketStatus } from './TicketStatusBadge.types'

const STATUS_MAP: Record<string, TicketStatus> = {
  approved: TicketStatus.APPROVED,
  waiting: TicketStatus.WAITING,
  settled: TicketStatus.SETTLED,
  cancelled: TicketStatus.CANCELLED,
  rejected: TicketStatus.REJECTED,
  lose: TicketStatus.LOSE,
  win: TicketStatus.WIN,
} as const

const CANCELLATION_REASON_MAP: Partial<Record<string, TicketStatus>> = {
  [TicketStatus.ROUND_CANCELLED]: TicketStatus.ROUND_CANCELLED,
  [TicketStatus.BET_FAILED]: TicketStatus.BET_FAILED,
  [TicketStatus.USER_CANCELLED]: TicketStatus.CANCELLED, // Map USER_CANCELLED reason to CANCELLED status for the entire ticket and all bet details
} as const

/**
 * Converts a string status (and optional cancellation reason) to a TicketStatus enum value.
 *
 * When cancellation_reason is provided it always takes priority over status:
 *  - Known reasons  → returned directly
 *  - Unknown reason → USER_CANCELLED (safe fallback; makes future gaps visible)
 *
 * @param status               - Raw status string from the item
 * @param cancellation_reason  - Optional cancellation reason from poll/ticket details
 */
export const getAsTicketStatus = (
  status: string,
  cancellation_reason?: string | null,
): TicketStatus => {
  if (cancellation_reason) {
    return (
      CANCELLATION_REASON_MAP[cancellation_reason] ?? TicketStatus.CANCELLED // Safe fallback for unknown reasons
    )
  }

  return STATUS_MAP[status.toLowerCase()] ?? TicketStatus.REJECTED
}
